module.exports = __webpack_public_path__ + "img/index06.757d7d9c.png";